import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { redirectToClinicPortal } from "../../../utils/portalHost";
import PlatformAuthShell from "../Auth/PlatformAuthShell";
import AuthField from "../Auth/AuthField";
import Button from "../../ui/Button";
import a from "../Auth/auth.module.css";
import L from "../../../constants/baysportLabels";
import Seo from "../../Seo";

const PORTAL_HINTS = {
  "/login": "вход в кабинет клуба",
  "/staff/login": "вход в кабинет клуба",
  "/manage/login": "вход в кабинет клуба",
  "/forgot-password": "сброс пароля",
  "/staff/forgot-password": "сброс пароля",
  "/manage/forgot-password": "сброс пароля",
};

export default function ClinicFinder() {
  const [searchParams] = useSearchParams();
  const targetPath = searchParams.get("to") || "/";
  const portalHint = PORTAL_HINTS[targetPath] || "портал клуба";
  const [slug, setSlug] = useState("");
  const [err, setErr] = useState("");

  const go = (e) => {
    e?.preventDefault?.();
    const sub = slug.trim().toLowerCase();
    if (!sub) {
      setErr("Введите адрес клуба");
      return;
    }
    setErr("");
    redirectToClinicPortal(sub, targetPath);
  };

  return (
    <>
      <Seo noindex title={`Найти клуб — ${L.productName}`} />
      <PlatformAuthShell
        backTo="/"
        backLabel="На главную"
        title="Найти клуб"
        subtitle={`Введите адрес, который дал администратор — откроется ${portalHint}.`}
        footer={
          <p className={a.platformFootNote}>
            Владелец секции?{" "}
            <Link to="/account/login">Войти в кабинет {L.productName}</Link>
            <br />
            Нет клуба?{" "}
            <Link to="/registraciya">Зарегистрировать секцию</Link>
          </p>
        }
      >
        <form onSubmit={go}>
          <AuthField
            label="Адрес клуба"
            value={slug}
            onChange={(e) => {
              setSlug(e.target.value);
              if (err) setErr("");
            }}
            placeholder="moyklub"
            hint="Только имя поддомена — без https:// и без точки"
            autoComplete="off"
            required
          />
          {err ? <div className={a.errorBox}>{err}</div> : null}
          <div className={a.actions}>
            <Button type="submit" block size="lg">
              Открыть клуб
            </Button>
          </div>
        </form>
      </PlatformAuthShell>
    </>
  );
}
